// Firebase Configuration
// We are removing the dynamic window check to ensure the app ALWAYS uses 
// your specific API key and project settings.
export const firebaseConfig = {
  apiKey: "AIzaSyCPaxf_zMlhoKbiaP3jTkuNpP7CYoe7P9k",
  authDomain: "idia-website.firebaseapp.com",
  projectId: "idia-website",
  storageBucket: "idia-website.firebasestorage.app",
  messagingSenderId: "571817412795",
  appId: "1:571817412795:web:c143b0114c709cf014019e",
  measurementId: "G-3F0NS3B68G"
};

export const APP_ID = 'idia-website';

// SECURITY: ONLY THESE EMAILS CAN ACCESS THE ADMIN DASHBOARD
// Cleaned up the duplicate entry.
export const ADMIN_EMAILS = [
  "hafizuddin.abuhasan@gmail.com"
];